<template>
  <div class="page">
    <div class="title">
      <div class="title-left ">
        <div class="title-left-top">
          <div class="name">汇通达网络股份有限公司</div>
          <div class="address">总部：江苏省南京市钟灵街50号汇通达大厦（邮编210008）</div>
        </div>
        <div class="title-left-bottom ">
          <div class="left">
            <div class="top">业务合作</div>
            <div class="bottom">4006399988</div>
          </div>
          <div class="line" />
          <div class="right">
            <div class="top">人才招聘</div>
            <div class="bottom">hr.zhaopin@htd.cn</div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle hide">
      <div class="left">
        <div class="top">
          加入汇通达
        </div>
        <div class="bottom">
          城乡无界  梦想无限
        </div>
      </div>
      <img src="@/assets/Mobile/images/icon/join-us.png">
    </div>
    <div class="content">
      <img src="@/assets/Mobile/images/icon/map.png">

    </div>

  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import JoinForm from '@/Mobile/Mobilecom/JoinForm'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
export default {
  metaInfo: metaInfo.Cooperate,
  components: {
    JoinForm,
    ContactForm,
    IndustrySolution
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.page{
  padding-top: 0.8rem;
  margin-top: 20px;
  text-align: left;
  .hide{
    display: none;
  }
  .title{
    padding: 10px;
    .name{
      font-weight: bold;
      font-size: 22px;
    }
    .address{
      font-size: 12px;
      margin-top: 5px;
    }
    .title-left-bottom{

      margin-top: 10px;
      display: none;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .top{
        font-weight: bold;
        font-size: 16px;
      }
      .bottom{
        margin-top: 5px;
        color:#707070
      }
      .line{
          height: 40px;
          border-left: 1px solid #dcdfe6;
      }

    }
  }
  .middle{
    margin-top: 50px;
    width: 100%;
    height: 72px;
    background: linear-gradient(to right, #ff7700, #ff9400);
    border-radius: 20px 20px 0 0;
    position: relative;
    .left{
      padding: 15px 0 10px 10px;
      color: #fff;
      .top{
        font-size: 16px;
      }
    }
    img{
      width: 120px;
      height: 120px;
      position: absolute;
      right:10px;
      top: -48px
    }
  }
  .content{
    width: 100%;
    height: 100%;
    margin-bottom: 20px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
